import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'
import {
    Card,
    Button,
    Classes,
    Collapse,
    Tag,
    Alert,
    Dialog,
} from '@blueprintjs/core'

import {
    groupRunbookActions,
    updateDashboardAction,
    groupByParent,
} from 'src/store/modules/ui/home'
import {
    asyncUpdateRunbookSession,
    collectHiddenActionUids,
} from 'src/store/modules/runbooks'
import * as paths from 'src/constants/paths'

class ActionCard extends React.Component {
    state = {
        confirmSuccessChildren: false,
        childrenOpen: false,
    }

    handleSuccess = () => {
        const { children, reverse } = this.props
        if (children.length && reverse) {
            this.setState({ confirmSuccessChildren: true })
        } else {
            this.props.onSuccess()
        }
    }

    handleSuccessConfirm = (success) => {
        this.props.onSuccess(success)
        this.setState({ confirmSuccessChildren: false })
    }

    renderChildrenAlert() {
        return this.state.confirmSuccessChildren ? (
            <Alert
                confirmButtonText="Yes"
                cancelButtonText="No"
                isOpen={true}
                onClose={this.handleSuccessConfirm}
            >
                <p>Would you like to propagate status?</p>
            </Alert>
        ) : null
    }

    populateActions(ids) {
        return ids.map((id) => this.props.byId[id])
    }

    renderChildrenDialog() {
        const { byId, grouped, updateAction } = this.props
        const childNodes = grouped[this.props.id] || []
        if (childNodes.length) {
            return (
                <div>
                    <Button
                        onClick={() => this.setState({ childrenOpen: true })}
                        small
                    >
                        Show split branch actions
                    </Button>
                    <Dialog
                        canOutsideClickClose={false}
                        icon="changes"
                        isOpen={this.state.childrenOpen}
                        onClose={() => this.setState({ childrenOpen: false })}
                        title="Children Of Action"
                    >
                        <div className="bp3-dialog-body">
                            {this.populateActions(childNodes).map((act) => (
                                <ActionCard
                                    updateAction={(
                                        runbookId,
                                        actionUid,
                                        data
                                    ) =>
                                        updateAction(runbookId, actionUid, data)
                                    }
                                    byId={byId}
                                    grouped={grouped}
                                    key={act.id}
                                    {...act}
                                    onSuccess={(propagate) =>
                                        updateAction(act.runbook, act.uid, {
                                            action: 'success',
                                            propagate,
                                        })
                                    }
                                    onFail={() =>
                                        updateAction(act.runbook, act.uid, {
                                            action: 'failed',
                                        })
                                    }
                                    onTake={() =>
                                        updateAction(act.runbook, act.uid, {
                                            action: 'take_ownership',
                                            user: this.props.user,
                                        })
                                    }
                                    onRelease={() =>
                                        updateAction(act.runbook, act.uid, {
                                            action: 'transfer',
                                            ownerType: 'group',
                                            name: act.ownerTeam,
                                        })
                                    }
                                />
                            ))}
                        </div>
                        <div className="bp3-dialog-footer"></div>
                    </Dialog>
                </div>
            )
        }
        return null
    }

    render() {
        const {
            uid,
            name,
            ownerUser,
            ownerTeam,
            description,
            reverse,
        } = this.props
        return (
            <Card
                elevation={2}
                interactive
                style={{ width: '25%', display: 'inline-block' }}
            >
                <h5>
                    <p>
                        <Tag>{uid}</Tag> {name}
                    </p>
                    {description ? (
                        <p>
                            <Tag minimal>{description}</Tag>
                        </p>
                    ) : null}
                    {reverse ? <Tag intent="primary">R</Tag> : null}
                </h5>
                {!ownerUser ? (
                    <Button
                        onClick={() => this.props.onTake()}
                        small
                        text="Take Ownership"
                        intent="warning"
                        className={Classes.BUTTON}
                        style={{ marginRight: 20 }}
                    />
                ) : null}
                <Button
                    onClick={this.handleSuccess}
                    small
                    text="Success"
                    intent="success"
                    className={Classes.BUTTON}
                    style={{ marginRight: 20 }}
                />
                <Button
                    onClick={() => this.props.onFail()}
                    small
                    text="Fail"
                    intent="danger"
                    className={Classes.BUTTON}
                />
                {ownerUser && ownerTeam ? (
                    <Button
                        onClick={() => this.props.onRelease()}
                        small
                        text="Release Ownership"
                        intent="warning"
                        className={Classes.BUTTON}
                    />
                ) : null}
                {this.renderChildrenDialog()}
                {this.renderChildrenAlert()}
            </Card>
        )
    }
}
// TODO: The following code was commented to temporary redirect to runbooks list

class ActionCardList extends React.Component {
    state = {
        isOpen: true,
    }

    populateActions(ids) {
        return ids.map((id) => this.props.byId[id])
    }

    render() {
        const { heading, actionList, byId, updateAction } = this.props
        const grouped = groupByParent(actionList, byId)
        return (
            <div>
                <Button
                    large
                    style={{ width: '100%' }}
                    onClick={() =>
                        this.setState({ isOpen: !this.state.isOpen })
                    }
                >
                    {heading}
                </Button>
                <Collapse className="flexd" isOpen={this.state.isOpen}>
                    {actionList.length ? (
                        this.populateActions(grouped[null]).map((act) => (
                            <ActionCard
                                byId={byId}
                                grouped={grouped}
                                updateAction={(runbookId, actionUid, data) =>
                                    updateAction(runbookId, actionUid, data)
                                }
                                key={act.id}
                                {...act}
                                onSuccess={(propagate) =>
                                    updateAction(act.runbook, act.uid, {
                                        action: 'success',
                                        propagate,
                                    })
                                }
                                onFail={() =>
                                    updateAction(act.runbook, act.uid, {
                                        action: 'failed',
                                    })
                                }
                                onTake={() =>
                                    updateAction(act.runbook, act.uid, {
                                        action: 'take_ownership',
                                        id: this.props.user.id,
                                    })
                                }
                                onRelease={() =>
                                    updateAction(act.runbook, act.uid, {
                                        action: 'transfer',
                                        contactType: 'team',
                                        id: act.ownerTeamId,
                                    })
                                }
                                user={this.props.user}
                                userId={this.props.userId}
                            />
                        ))
                    ) : (
                        <h4
                            style={{
                                margin: '20px auto',
                            }}
                        >
                            No actions here
                        </h4>
                    )}
                </Collapse>
            </div>
        )
    }
}

class Home extends React.Component {
    componentDidMount() {
        document.title = 'Dashboard | Runbooks'
    }
    render() {
        const {
            userActions,
            groupActions,
            byId,
            actions: { asyncUpdateRunbookSession },
        } = this.props

        // FIXME: temporary added to redirect to runbooks list page
        const REDIRECT_TO_RUNBOOKS = true

        return REDIRECT_TO_RUNBOOKS ? (
            <Redirect to={paths.LIST_PATH} />
        ) : (
            <div style={{ textAlign: 'center', padding: 30 }}>
                {groupActions
                    ? Object.entries(groupActions).map(([name, actionList]) => (
                          <ActionCardList
                              byId={byId}
                              heading={name}
                              actionList={actionList}
                              updateAction={(runbookId, actionUid, data) =>
                                  asyncUpdateRunbookSession(
                                      runbookId,
                                      [actionUid],
                                      data
                                  )
                              }
                              key={name}
                              user={this.props.user}
                              userId={this.props.userId}
                          />
                      ))
                    : null}
                {userActions ? (
                    <ActionCardList
                        byId={byId}
                        heading="My Actions"
                        actionList={userActions}
                        updateAction={(runbookId, actionUid, data) =>
                            asyncUpdateRunbookSession(
                                runbookId,
                                [actionUid],
                                data
                            )
                        }
                        user={this.props.user}
                        userId={this.props.userId}
                    />
                ) : null}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { runbookActions, userRunbooks } = state.ui.home
    return {
        userId: state.app.userId,
        user: state.app.user,
        userRunbooks,
        ...groupRunbookActions(state.app.userId, runbookActions),
    }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    dispatch,
    actions: bindActionCreators(
        {
            updateDashboardAction,
            asyncUpdateRunbookSession: (runbookId, actionUids, data) => {
                // Create a thunk that gets the state and collects hidden action UIDs
                return (innerDispatch, getState) => {
                    const state = getState()
                    const runbook = state.runbooks?.byId?.[runbookId]
                    const hiddenActionUids = collectHiddenActionUids(
                        runbook?.actions?.byId
                    )

                    return innerDispatch(
                        asyncUpdateRunbookSession(
                            runbookId,
                            actionUids,
                            data,
                            hiddenActionUids
                        )
                    )
                }
            },
        },
        dispatch
    ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Home)
